import React from 'react'

import { reportListData } from '../@signals'
import { reportSearchesModalId } from '@signals'
import { AppReportSearchesModal } from '@components'


export default function ReportListSearchSummaryModal() {

	if (!reportSearchesModalId.value) return null

	return <AppReportSearchesModal data={reportListData.value}/>
}